import { getInfoBookedNow } from "@/utils/booked";

const getters = {
  isShowLoginDialog: state => state.login.isShowLoginDialog,
  bg: state => state.styleConfig.style,
  bgHeader: state => state.styleConfig.headersPage,
  list_golfer: state => state.detailTeetime.list_golfer,
  list_golfer_out: state => state.detailTeetime.list_golfer_out,
  list_golfer_booking: state => {
    if (!state.detailTeetime.list_golfer_booking.facility_name) {
      return getInfoBookedNow();
    }
    return state.detailTeetime.list_golfer_booking;
  },
  checked: state => state.detailTeetime.checked,
  showServiceIcon: state => state.detailTeetime.showServiceIcon,
  body_booking_fast: state => state.booking.body_booking_fast,
  listPriceFacility: state => state.booking.listPriceFacility,
  review_facility: state => state.booking.review_facility,
  list_news: state => state.booking.list_news,
  list_news_top: state => state.booking.list_news_top,

  point: state => state.point.point,
  isShowOtp: state => state.login.isShowOtp,
  phone_number: state => state.login.phone_number,
  otp: state => state.login.otp,
  isShowProfile: state => state.login.isShowProfile,
  isShowWallet: state => state.login.isShowWallet,
  isShowSearchFacility: state => state.booking.isShowSearchFacility,
  isReRenderComponent: state => state.login.isReRenderComponent,
  isLoadingPage: state => state.login.isLoadingPage,
  isShowMenuApp: state => state.login.isShowMenuApp,
  list_teetime: state => state.booking.list_teetime,
  list_category_tee: state => state.booking.list_category_tee,
  isShowUpdateInfo: state => state.login.isShowUpdateInfo,
  titleDialogUpdateInfo: state => state.login.titleDialogUpdateInfo,
  info_banner: state => state.banner.info
};
export default getters;
